import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Login from "./components/LoginComponent";
import BanquetBookingMUI from "./components/BanquetBookingMUI";
import BanquetBookingHistory from "./components/BanquetBookingHistory";
import AdvanceBooking from "./components/AdvanceBooking";
import AdvanceBookingTable from "./components/AdvanceBookingTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
      <Routes>
        {/* Login Page */}
        <Route path="/" element={<Login />} />

        {/* Room Advance Booking */}
        <Route path="/advance-booking" element={<AdvanceBooking />} />

        {/* Banquet Booking */}
        <Route path="/banquet" element={<BanquetBookingMUI />} />

        {/* Banquet Booking History */}
        <Route path="/banquet-history" element={<BanquetBookingHistory />} />
        <Route path="/advance-booking-history" element={<AdvanceBookingTable />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
